import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { EWorkOrderStatus } from '@web/enums/work-order-status.enum';

import { TranslateService } from '@ngx-translate/core';
import { EContractStatus, ESpecificContractStatus } from '@web/enums/contract-status.enum';
import { EStatusType } from '@web/enums/status-type.enum';
import { eEntitiesStatus } from '@web/enums/app.enum';
import { Contract } from '@common/core/models';

@Component({
  selector: 'tim-status-chip',
  templateUrl: './status-chip.component.html',
  styleUrl: './status-chip.component.scss',
  standalone: false,
})
export class StatusChipComponent implements OnChanges {
  @Input() status: EWorkOrderStatus | EContractStatus | ESpecificContractStatus;
  @Input() type: EStatusType;
  @Input() contract: Contract;
  @Input() isEditable: boolean = false;
  @Output() statusChange: EventEmitter<EWorkOrderStatus> = new EventEmitter<EWorkOrderStatus>();

  public eStatus = eEntitiesStatus;
  public statusClass = '';
  public statusOptions = [];

  constructor(public translateService: TranslateService) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.status || changes.contract) {
      this.loadStatusChip();
      switch (this.type) {
        case 'CONTRACT':
          this.statusOptions = Object.values(EContractStatus);
          break;

        case 'WORK_ORDER':
          this.statusOptions = Object.values(EWorkOrderStatus);
          break;

        default:
          break;
      }
    }
  }

  onStatusChange(newStatus: EWorkOrderStatus) {
    this.statusChange.emit(newStatus);
  }

  loadStatusChip() {
    switch (this.status) {
      case eEntitiesStatus.COMPLETED:
        this.statusClass = 'completed-chip';
        break;

      case eEntitiesStatus.PARTIAL:
      case eEntitiesStatus.OPEN:
      case eEntitiesStatus.TAKEN_OVER_CO:
      case eEntitiesStatus.TAKEN_OVER_DELIVERY_ON_SITE:
      case eEntitiesStatus.TAKEN_OVER_PURCHASING:
        this.statusClass = 'partial-chip';
        break;
      case eEntitiesStatus.SUPPLY_TESTING_EM_PARTIAL_OR_TOTAL:
        this.statusClass = 'partial-chip';
        this.status = eEntitiesStatus.SUPPLY_TESTING_EM_PARTIAL;
        if (this.contract && this.contract.workOrders) {
          const allEntryGoodsComplete = this.contract.workOrders.every(
            workOrder => workOrder.entryGoodsStatus === eEntitiesStatus.COMPLETED
          );

          if (allEntryGoodsComplete && this.contract.workOrders.length > 0) {
            this.statusClass = 'completed-chip';
            this.status = eEntitiesStatus.SUPPLY_TESTING_EM_TOTAL;
            return;
          }
        }
        break;

      default:
        this.statusClass = '';
        break;
    }
  }
}
